/**
 * Offers page — add bundle products to cart from cards.
 */
class MobileOffersPage {
  /** @param {HTMLElement} root */
  constructor(root) {
    this.root = root;
    this.bindAddToCart();
  }

  bindAddToCart() {
    this.root.addEventListener('click', async (event) => {
      const button = event.target.closest('.scp-card__atc--offerspage');
      if (!button || button.disabled) return;

      event.preventDefault();
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Adding…';

      try {
        const cart = window.Theme?.storefrontCart;
        if (cart?.addVariantToCart) {
          await cart.addVariantToCart(button.dataset.variantId, 1);
          cart.openThemeCartDrawer?.();
        } else {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
          });
          if (!response.ok) throw new Error('Add failed');
          document.querySelector('theme-drawer#cart-drawer')?.open?.();
        }
        button.textContent = 'Added';
      } catch (error) {
        console.error(error);
        button.textContent = originalText;
      } finally {
        window.setTimeout(() => {
          button.disabled = false;
          if (button.textContent === 'Added') button.textContent = originalText;
        }, 1200);
      }
    });
  }
}

document.querySelectorAll('[data-mobile-offers-page]').forEach((root) => {
  new MobileOffersPage(root);
});
